<template>
  <router-view class="content-wrapper"></router-view>
</template>

<script>
import MenuBar from '@/components/admin/menu'
import Container from '@/components/general/container'
import Column from '@/components/general/column'
import Columns from '@/components/general/columns'

export default {
  components: { MenuBar, Container, Column, Columns }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.admin-content {
  margin-top: -1.5rem;
  padding-left: 1rem;
  padding-right: 2rem;
  margin-bottom: -1rem;
  height: calc(100vh - #{$navbar-height});
  overflow-y: auto;
}
@media screen and (max-width: $tablet) {
    .admin-content {
      margin-top: 0rem;
      margin-bottom: 0rem;
      padding-right: 1rem;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/index.vue